import styled from 'styled-components';
import TextField from '@material-ui/core/TextField';
import { Button } from '@material-ui/core';
import colors from '../../styles/settings/colors';

export const Root = styled.div`
  background: #f2f1f1;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  overflow-x: hidden;
  width: 100%;
`;

export const Content = styled.div`
  align-items: center;
  box-sizing: border-box;
  column-gap: 16px;
  display: grid;
  grid-template-columns: 30% 70%;
  margin-top: 27vh;
  padding: 0 16px;
  width: 100%;

  .message-html {
    align-self: flex-start;
    background: white;
    border-radius: 4px;
    border: solid #c4c4c4 1px;
    box-shadow: 0px 0px 2px rgb(66 66 66 / 9%);
    margin: 0 28px;
    padding: 8px 48px;
    position: relative;
    top: 8px;
  }
`;

export const PasswordBox = styled.div`
  display: flex;
  flex-flow: row wrap;

  .container-password {
    margin: 0 64px;
    max-width: 500px;
  }

  .icon-show {
    margin-left: 425px;
    margin-right: 16px;
    margin-top: -48px;
    position: absolute;
    z-index: 3;
  }
`;

export const InputLabel = styled.label`
  bottom: 7px;
  font-size: 13px;
  font-weight: bold;
  margin-bottom: 7px;
  padding-bottom: 8px;
  position: relative;
`;

export const InputText = styled(TextField)`
  text-transform: uppercase;
  width: 100%;

  .MuiInputBase-input {
    color: ${colors.tundora}!important;
  }

  .MuiInputBase-root {
    height: 48px;
    padding: 0 8px;
  }

  .MuiInputBase-root.Mui-disabled {
    background: #e0e0e0;
  }
`;

export const ActionFooter = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-end;
  padding: 16px 8px;
  width: 100%;
`;

export const ActionButton = styled(Button)`
  background-color: ${colors.sanMarino}!important;
  color: ${colors.white}!important;
  font-size: 13px !important;
  min-width: 200px !important;
`;
